import { opponentCarriesFromOffensiveGameStats, opponentConversionsFromConversions, opponentDropGoalsFromDropGoals, opponentFoulsFromFouls, opponentMetersCarriedFromOffensiveGameStats, opponentOffloadsFromOffensiveGameStats, opponentPassesFromOffensiveGameStats, opponentPenaltyGoalsFromPenaltyKicks, opponentPenaltyKicksFromPenaltyKicksAndKickingGameStats, opponentPointsFromStats, opponentRedCardsFromFouls, opponentTriesFromTries, opponentYellowCardsFromFouls, ourCarriesFromOffensiveGameStats, ourCleanBreaksFromOffensiveGameStats, ourConversionsFromConversions, ourDefendersBeatenFromOffensiveGameStats, ourDropGoalsFromDropGoals, ourFoulsFromFouls, ourKickingInPlayFromKickingGameStats, ourLineoutsLostFromSetPlaysGameStats, ourLineoutsWonFromSetPlaysGameStats, ourMetersCarriedFromOffensiveGameStats, ourMissedTacklesFromDefensiveGameStats, ourOffloadsFromOffensiveGameStats, ourPassesFromOffensiveGameStats, ourPenaltyGoalsFromPenaltyKicks, ourPenaltyKicksFromPenaltyKicksAndKickingGameStats, ourPlusAndMinusFromOffensiveGameStats, ourPointsFromStats, ourRedCardsFromFouls, ourScrumsLostFromSetPlaysGameStats, ourScrumsWonFromSetPlaysGameStats, ourTacklesFromDefensiveGameStats, ourTriesFromTries, ourTurnoversConcededFromOffensiveGameStats, ourTurnoversWonFromDefensiveGameStats, ourYellowCardsFromFouls } from './RugbyStats';

export const ourRugbyResultFromGame = (game: any) => {
    if (game.status === 'finished') {
        if (game.winOrLoss === 'win') {
            return 'Win';
        } if (game.winOrLoss === 'tied') {
            return 'Tied';
        } if (game.winOrLoss === 'loss') {
            return 'Loss';
        }
        return '-';
    }
    return '-';
};

export const ourRugbyShortenedResultFromGame = (game: any) => {
    if (game.status === 'finished') {
        if (game.winOrLoss === 'win') {
            return 'W';
        } if (game.winOrLoss === 'tied') {
            return 'T';
        } if (game.winOrLoss === 'loss') {
            return 'L';
        }
        return '-';
    }
    return '-';
};

export const ourTriesFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourTriesFromTries(game.tries);
    }
    return 0;
};

export const ourConversionsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourConversionsFromConversions(game.conversions);
    }
    return 0;
};

export const ourPenaltyKicksFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourPenaltyKicksFromPenaltyKicksAndKickingGameStats(game.penaltyKicks, game.kickingGameStats);
    }
    return 0;
};

export const ourPenaltyGoalsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourPenaltyGoalsFromPenaltyKicks(game.penaltyKicks);
    }
    return 0;
};

export const ourDropGoalsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourDropGoalsFromDropGoals(game.dropGoals);
    }
    return 0;
};

export const ourPointsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourPointsFromStats(game.tries, game.conversions, game.penaltyKicks, game.dropGoals);
    }
    return 0;
};

export const ourFoulsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourFoulsFromFouls(game.fouls);
    }
    return 0;
};

export const ourYellowCardsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourYellowCardsFromFouls(game.fouls);
    }
    return 0;
};

export const ourRedCardsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourRedCardsFromFouls(game.fouls);
    }
    return 0;
};

export const ourPassesFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourPassesFromOffensiveGameStats(game.offensiveGameStats);
    }
    return 0;
};

export const ourOffloadsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourOffloadsFromOffensiveGameStats(game.offensiveGameStats);
    }
    return 0;
};

export const ourCarriesFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourCarriesFromOffensiveGameStats(game.offensiveGameStats);
    }
    return 0;
};

export const ourMetersCarriedFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourMetersCarriedFromOffensiveGameStats(game.offensiveGameStats);
    }
    return 0;
};

export const ourDefendersBeatenFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourDefendersBeatenFromOffensiveGameStats(game.offensiveGameStats);
    }
    return 0;
};

export const ourTurnoversConcededFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourTurnoversConcededFromOffensiveGameStats(game.offensiveGameStats);
    }
    return 0;
};

export const ourCleanBreaksFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourCleanBreaksFromOffensiveGameStats(game.offensiveGameStats);
    }
    return 0;
};

export const ourPlusAndMinusFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourPlusAndMinusFromOffensiveGameStats(game.offensiveGameStats);
    }
    return 0;
};

export const ourKickingInPlayFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourKickingInPlayFromKickingGameStats(game.kickingGameStats);
    }
    return 0;
};

export const ourMissedTacklesFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourMissedTacklesFromDefensiveGameStats(game.defensiveGameStats);
    }
    return 0;
};

export const ourTacklesFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourTacklesFromDefensiveGameStats(game.defensiveGameStats);
    }
    return 0;
};

export const ourTurnoversWonFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourTurnoversWonFromDefensiveGameStats(game.defensiveGameStats);
    }
    return 0;
};

export const ourLineoutsWonFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourLineoutsWonFromSetPlaysGameStats(game.setPlaysGameStats);
    }
    return 0;
};

export const ourLineoutsLostFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourLineoutsLostFromSetPlaysGameStats(game.setPlaysGameStats);
    }
    return 0;
};

export const ourScrumsWonFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourScrumsWonFromSetPlaysGameStats(game.setPlaysGameStats);
    }
    return 0;
};

export const ourScrumsLostFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourScrumsLostFromSetPlaysGameStats(game.setPlaysGameStats);
    }
    return 0;
};

// ---------------------------------------------------------------------------------------------------------
// Get opponent game stats
// ---------------------------------------------------------------------------------------------------------

export const opponentRugbyResultFromGame = (game: any) => {
    if (game.status === 'finished') {
        if (game.winOrLoss === 'win') {
            return 'Loss';
        } if (game.winOrLoss === 'tied') {
            return 'Tied';
        } if (game.winOrLoss === 'loss') {
            return 'Win';
        }
        return '-';
    }
    return '-';
};

export const opponentRugbyShortenedResultFromGame = (game: any) => {
    if (game.status === 'finished') {
        if (game.winOrLoss === 'win') {
            return 'L';
        } if (game.winOrLoss === 'tied') {
            return 'T';
        } if (game.winOrLoss === 'loss') {
            return 'W';
        }
        return '-';
    }
    return '-';
};

export const opponentTriesFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentTriesFromTries(game.tries);
    }
    return 0;
};

export const opponentConversionsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentConversionsFromConversions(game.conversions);
    }
    return 0;
};

export const opponentPenaltyKicksFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentPenaltyKicksFromPenaltyKicksAndKickingGameStats(game.penaltyKicks, game.kickingGameStats);
    }
    return 0;
};

export const opponentPenaltyGoalsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentPenaltyGoalsFromPenaltyKicks(game.penaltyKicks);
    }
    return 0;
};

export const opponentDropGoalsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentDropGoalsFromDropGoals(game.dropGoals);
    }
    return 0;
};

export const opponentPointsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentPointsFromStats(game.tries, game.conversions, game.penaltyKicks, game.dropGoals);
    }
    return 0;
};

export const opponentFoulsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentFoulsFromFouls(game.fouls);
    }
    return 0;
};

export const opponentYellowCardsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentYellowCardsFromFouls(game.fouls);
    }
    return 0;
};

export const opponentRedCardsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentRedCardsFromFouls(game.fouls);
    }
    return 0;
};

export const opponentPassesFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentPassesFromOffensiveGameStats(game.offensiveGameStats);
    }
    return 0;
};

export const opponentOffloadsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentOffloadsFromOffensiveGameStats(game.offensiveGameStats);
    }
    return 0;
};

export const opponentCarriesFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentCarriesFromOffensiveGameStats(game.offensiveGameStats);
    }
    return 0;
};

export const opponentMetersCarriedFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentMetersCarriedFromOffensiveGameStats(game.offensiveGameStats);
    }
    return 0;
};
